<template>
  <div class="tabs p-5">
    <div class="border rounded-md border-gray-300 shadow-sm pb-2">
      <div class="tab-nav flex justify-between items-center w-full px-5 border-b justify">
        <h2 class="font-bold text-blue-500 text-xl flex items-center py-2.5">
          <button @click="nextTo()" class="pr-2">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
              <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
            </svg>
          </button>
          <p v-text="this.user.lastName + ' ' + this.user.firstName"></p>
        </h2>
      </div>
      <div class="tab-content border-0 px-7">
        <div class="py-2 align-middle inline-block min-w-full">
          <div class="border overflow-hidden border-b border-gray-200 sm:rounded-lg">
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-100">
                <tr>
                  <th scope="col" class="w-14 px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Designation</th>
                  <th scope="col" class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                  <th scope="col" class="px-3 py-2 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Select</th>
                </tr>
              </thead>
              <tbody class="bg-white divide-y divide-gray-200">
                <tr v-for="item in paginatedData" :key="item.name">
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x">
                    <p class="text-base whitespace-normal text-justify">{{ item.title }}</p>
                  </td>
                  <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 border-x">
                    <p class="text-base whitespace-normal text-center">{{ item.name }}</p>
                  </td>
                  <td class="text-center whitespace-nowrap text-sm text-gray-500 border-l">
                    <input type="checkbox" :checked="isRoleSelected(item.name)" @change="handleRoleChange(item, $event)" />
                  </td>
                </tr>
                <tr v-if="filteredData.length === 0">
                  <td colspan="5" class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    Запрашиваемый элемент не найден.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-show="loading">
      <LoadingPage message="Выполняется загрузка ..."></LoadingPage>
    </div>
  </div>
</template>

<script>
import LoadingPage from "@/components/LoadingPage";
export default {
  beforeRouteLeave(to, from, next) {
    sessionStorage.removeItem("CURRENT_USER");
    next();
  },
  components: {
    LoadingPage,
  },
  data() {
    return {
      currentPage: 1,
      itemsPerPage: 7,
      searchQuery: "",
      roles: [],
      userRole: [],
      user: {
        id: "",
        firstName: null,
        lastName: null,
        email: null,
        phoneNumber: null,
        userName: null,
        confirmPassword: null,
        password: null
      },
      loading: true,
      selectedTable1: [] // IDs of selected items
    };
  },
  computed: {
    filteredData() {
      let filteredItems = this.roles;

      if (this.searchQuery) {
        filteredItems = filteredItems.filter((item) => {
          return item.keyWordRu
            .toLowerCase()
            .includes(this.searchQuery.toLowerCase());
        });
      }

      return filteredItems;
    },
    paginatedData() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.filteredData.slice(startIndex, endIndex);
    },
    totalPages() {
      return Math.ceil(this.filteredData.length / this.itemsPerPage);
    },
    pageNumbers() {
      const pages = [];
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    nextTo(){
        this.$router.push('/allUser')
    },
    async loadTableData() {
      try {
        const response = await this.axios.get("/api/Admin/Role/GetAll");
        this.roles = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async userRoles() {
      try {
        const response = await this.axios.get(`/api/Admin/User/GetAllRole/${this.user.id}`);
        this.userRole = response.data;
        // Инициализация selectedTable1 на основе полученных данных
        this.selectedTable1 = this.userRole.roles.map(role => role.name);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    isRoleSelected(roleName) {
      return this.selectedTable1.includes(roleName);
    },
    async handleRoleChange(item, event) {
      if (event.target.checked) {
        await this.addRole(item);
      } 
      else {
        await this.removeRole(item);
      }
    },
    async addRole(item) {
      
      try {
        const userRoleDTO = {
        UserId: this.user.id,
        Roles: [{ Name: item.name }]
        };
        await this.axios.post('/api/Admin/User/AddRoleToUser', userRoleDTO);
          this.selectedTable1.push(item.name);
      } 
      catch (error) {
          console.log(error);
      }
    },
    async removeRole(item) {
      try {
        const userRoleDTO = {
        UserId: this.user.id,
        Roles: [{ Name: item.name }]
        };
        await this.axios.post('/api/Admin/User/RemoveRoleFromUser',userRoleDTO);
        this.selectedTable1 = this.selectedTable1.filter(name => name !== item.name);
      } catch (error) {
        console.log(error);
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber;
    },
  },
  mounted() {
    this.loadTableData();
    if (sessionStorage.getItem("CURRENT_USER")) {
      this.user = JSON.parse(sessionStorage.getItem("CURRENT_USER"));
      this.userRoles();
    }
  },
};
</script>

<style>
.active {
  background-color: #3b82f6;
  color: white;
}
.btn {
  margin-left: auto;
}
</style>